module.exports = "<div class=\"qdt-tooltip\" id=\"qdt-tooltip\">test</div>\r\n<button class=\"lui-button tooltip-trigger\" aria-haspopup=\"true\" title=\"This is the tooltip text to be displayed\">Default</button>\r\n<div id=\"barchart\" style=\"height:400px;position:relative;\"></div>\r\n<div id=\"scotterplot\" style=\"height:400px;position:relative;\"></div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/picasso/picasso.component.html
// module id = ./src/app/components/picasso/picasso.component.html
// module chunks = main